import React from 'react';

import { Link } from 'react-router-dom';
import { Layout } from 'components/organisms/layout';
import { ContentsTitle, } from 'components/molecules';
/** styles **/
import s from '../styles/pages/p-man-comic.module.scss';
import { ReactComponent as BlackCircleArrow } from 'assets/images/black-circle-arrow.svg';
import { Comics } from 'components/organisms/comics';

export const PmanComic: React.FC = () => {
  return (
    <Layout>
      <div className={s.comicPageWrapper}>
        <ContentsTitle className={s.contentsTitle} title="皆さまの４コマ劇場" subTitle="4コマ漫画でわかるペットライフ" />
        <p className={s.sectionNote}>本件は事業化検討段階のため内容が変更となる場合があります</p>
        <div className={s.worriesList}>
          <Comics />
        </div>

        <Link className={s.topLink} to="/">
          <BlackCircleArrow className={s.navButton} />トップページへ戻る
        </Link>
      </div>
    </Layout>
  );
};
